import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { SessionStorageService } from '../services/session-storage.service';
import { EnvironmentService } from '../services/environment.service';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FundFeeLookupService {
  private http = inject(HttpClient);
  private rbs = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);
  private envSvc = inject(EnvironmentService);

  constructor() {
    this.environment = this.envSvc.get();
    this.org = this.environment.org;
  }

  private feeCalcDataSource = new Subject();
  feeCalcData$ = this.feeCalcDataSource.asObservable();

  private environment;
  private org: string;

  calculate(data) {
    const sessId = this.ss.get('session');
    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', sessId)
      .set('X-RB-I', 'iw')
      .set('X-RB-O', this.org);
    return this.rbs.postRequest<any>(
      `${this.rbs.baseUrl}/Process/PortfolioCalc`,
      data,
      reqHeaders
    );
  }

  calculationData(ann) {
    this.feeCalcDataSource.next(ann);
  }
}
